export const metaFields = `
  meta {
    key
    value
  }
`;
